import type { Variants } from 'motion/react';

export const IconVariant: Variants = {
    initial: {
        opacity: 0,
        x: -30,
    },
    animate: {
        opacity: 1,
        x: 0,
    },
};
